/**
* @name: menu-item
* @author: weiyong
* @date: 2023-03-18 21:10
* @description：menu-item
* @update: 2023-03-18 21:10
*/
<template>
 <div class="menu-item">
   <MenuItem v-if="oneMenuItem.children==null||oneMenuItem.children.length===0" :key="String(oneMenuItem.id || oneMenuItem.path)">
     <template #icon>
       <span style="font-size: 20px;" :class="oneMenuItem.source||'remix-icon ri-file-list-line'"></span>
     </template>
     {{ t(oneMenuItem.name) }}
   </MenuItem>

   <SubMenu v-else :key="oneMenuItem.id" >
     <template #icon>
       <Icon v-if="oneMenuItem.icon" :icon="oneMenuItem.icon" :size="18" />
       <i :title="oneMenuItem.name" style="font-size: 18px;" v-else :class="oneMenuItem.source || 'gm going-icon-wenjian2-xian'"></i>
     </template>
     <template #title>{{ oneMenuItem.name }}</template>

     <template :key="sonItem.id" v-for="sonItem in oneMenuItem.children">
       <MenuItem v-if="sonItem.children==null||sonItem.children.length===0" :key="String(sonItem.id || sonItem.path)">
         <div :title="sonItem.name" style="display: flex;">
           <div>
              <span class="arch-menu-item-icon">
                <Icon v-if="sonItem.icon" :icon="sonItem.icon" :size="18" />
                <i  style="font-size: 18px;" v-else :class="sonItem.source || 'gm going-icon-wenjian2-xian'"></i>
              </span>
           </div>
           <div style="padding-left: 8px;">{{ sonItem.name }}</div>
         </div>
       </MenuItem>

       <app-menu-item v-else :oneMenuItem="sonItem"/>
     </template>

   </SubMenu>
 </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
const componentParam={
  appMenuItem:defineAsyncComponent(() => import('../appFrameCom/app-menu-item.vue')),
};

export default defineComponent({
  components: {
    ...componentParam,
  },
  name: "app-menu-item",
});
</script>

<script lang="ts" setup>

import { Menu,SubMenu,MenuItem } from 'ant-design-vue';
import {useDesign} from "@/hooks/web/useDesign";

const {t} = useI18n()
const {prefixCls} = useDesign('menu-item');

interface propTypes{
  oneMenuItem:any
}
const props=withDefaults(defineProps<propTypes>(),{
  oneMenuItem:{}
})
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-menu-item';

.@{prefix-cls} {

}
</style>
